import API from "../utils/api";
import {
    API_START,
    API_SUCCESS,
    API_FAIL,
    EDIT_PLAYER_DETAILS_FAIL,
    EDIT_PLAYER_DETAILS_START,
    EDIT_PLAYER_DETAILS_SUCCESS,
    DELETE_ROW_FAIL,
    DELETE_ROW_START,
    DELETE_ROW_SUCCESS,
    API_FAIL_OTHER,
    API_SUCCESS_OTHER,
    ADD_MEMBER_CREDIT_START,
    ADD_MEMBER_CREDIT_SUCCESS,
    ADD_MEMBER_CREDIT_FAIL,
    API_OTHER_DATA_RESET
} from "../../constants/type";
import config from "../../constants/config";
import constant from "../../constants/constant";

/*
Below function is used to fetch the player data from api
*/
export const getPlayerListing = (data, length, isCSAdmin) => {
    return async function (dispatch) {
        let requestPayload = "";
        dispatch({ type: API_START });
        if (data.ManagePlayerPage) {
            const { searchBy } = data
            requestPayload = `?limit=` + 10 + `&pageNumber=` + (data.activePage ? data.activePage : "") + `&fullName=` + searchBy.playername + `&email=` + searchBy.email.replace("+", "%2B") + `&statusId=` + searchBy.statusId + `&mobile=` + searchBy.contactno + `&clubId=` + searchBy.clubId
        } else {
            const { searchBy } = data
            requestPayload = `?limit=` + 10000 + `&pageNumber=` + (data.activePage ? data.activePage : "") + `&fullName=` + searchBy.playername + `&email=` + searchBy.email.replace("+", "%2B") + `&statusId=` + searchBy.statusId + `&mobile=` + searchBy.contactno + `&clubId=` + searchBy.clubId
        }
        // }
        await API.getRequest(`${config.BASE_URL}/player` + requestPayload)
            .then(response => {
                dispatch({ type: API_SUCCESS, payload: response });
            })
            .catch(error => {
                if (error.response && (error.response.status === 500 || error.response.status === 400)) {
                    return dispatch({
                        type: API_FAIL,
                        payload: error.response.data.message
                    });
                }
                else
                    dispatch({
                        type: API_FAIL,
                        payload: error
                    });
            });


    }
}

export const getOtherPlayerListing = (data, length, isCSAdmin) => {
    return async function (dispatch) {
        let requestPayloadOtherTab = "";
        if (!data.paymentMembersPage && (data?.hideSelectedClubOnOtherPlayer || data.check)) {
            if (length === 0 && !isCSAdmin) {
                dispatch({ type: API_OTHER_DATA_RESET });
            } else {
                const { searchBy } = data
                requestPayloadOtherTab = `?limit=` + config.PAGE_SIZE + `&pageNumber=` + data.activePageOther + `&fullName=` + searchBy.playername_other + `&email=` + searchBy.email_other.replace("+", "%2B") + `&statusId=` + searchBy.statusId_other + `&mobile=` + searchBy.contactno_other + `&clubId=` + searchBy.clubId

                API.getRequest(`${config.BASE_URL}/player/clubIdNotAssociated` + requestPayloadOtherTab)
                    .then(response => {
                        dispatch({ type: API_SUCCESS_OTHER, payload: response });
                    })
                    .catch(error => {
                        if (error.response && (error.response.status === 500 || error.response.status === 400)) {
                            return dispatch({
                                type: API_FAIL_OTHER,
                                payload: error.response.data.message
                            });
                        }
                        else
                            dispatch({
                                type: API_FAIL_OTHER,
                                payload: error
                            });
                    });
            }
        }
    }
}



export const getSinglePlayerDetailsAction = (playerId, type, history, clubId, isOther) => {
    return function (dispatch) {
        dispatch({ type: EDIT_PLAYER_DETAILS_START });

        API.getRequest(`${config.BASE_URL}/player/${playerId}`)
            .then(response => {
                if (type === constant.VIEW) {
                    dispatch({ type: EDIT_PLAYER_DETAILS_SUCCESS, payload: response });
                } else if (type === constant.EDIT) {
                    dispatch({ type: EDIT_PLAYER_DETAILS_SUCCESS, payload: response });
                    history.push({
                        pathname: '/add-player',
                        state: { clubid: clubId, playerId: playerId, type: type, detail: response, isOther: isOther }
                    })
                }

            })
            .catch(error => {
                dispatch({ type: EDIT_PLAYER_DETAILS_FAIL, payload: error });
            });
    };
}



/* The below Action delete the single row.
*/
export const deleteSingleRecordsAction = (requestPayload) => {
    return async function (dispatch) {
        dispatch({ type: DELETE_ROW_START });
        await API.deleteRequestWithBody(`${config.BASE_URL}/player/association`, requestPayload)
            .then(response => {
                //success API response
                return dispatch({
                    type: DELETE_ROW_SUCCESS,
                    payload: response.message
                });
            })
            .catch(error => {
                //failed Api response
                return dispatch({ type: DELETE_ROW_FAIL, payload: (requestPayload.page === "managePlayer" && (error.response.status === 500 || error.response.status === 400)) ? error.response.data : error });
            });
    }
}

export const getExistingPlayerDetailsAction = (playerEmail) => {
    return async function (dispatch) {
        dispatch({ type: EDIT_PLAYER_DETAILS_START });
        await API.getRequest(`${config.BASE_URL}/player/email/${playerEmail}`)
            .then(response => {
                dispatch({ type: EDIT_PLAYER_DETAILS_SUCCESS, payload: response });
            })
            .catch(error => {
                dispatch({ type: EDIT_PLAYER_DETAILS_FAIL, payload: error });
            });
    };
}

export const addMemberCredit = (reqPayload) => {
    return async function (dispatch) {
        dispatch({ type: ADD_MEMBER_CREDIT_START });
        await API.postRequest(`${config.BASE_URL}/player/addcredit`, reqPayload)
            .then(response => {
                dispatch({ type: ADD_MEMBER_CREDIT_SUCCESS, payload: response });
            })
            .catch(error => {
                dispatch({ type: ADD_MEMBER_CREDIT_FAIL, payload: error });
            });
    };
}